import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NitroNavBar, NitroPanel } from 'nitro-components';
import IframeResizer from 'react-iframe-resizer-super';

import SectionHeader, {
  LeftSection,
} from '../../components/layouts/SectionHeader';
import * as routes from '../../routes/const';
import Breakpoint from '../../utils/breakpoints';
import { NitroLoading } from 'nitro-components/build/nitro';
import YellowfinIframe from './YellowfinIframe'

import * as Routes from '@src/routes/const'

const iframeResizerOptions = {
  checkOrigin: false,
  log: false,
};

const OverflowPanel = styled.div`
  width: 100%;

  @media (max-width: 1345px) {
    overflow-x: scroll;
  }
`

const NitroPanelExtended = styled(NitroPanel)`
  min-height:80px;
  min-width: 1342px;
  max-width: 1342px;

  @media (max-width: 1025px) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }
`;

class EmbedDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yfparams: null,
      yfheight: 2000,
    };

    this.iframeRef = null;
  }

  componentDidMount() {
    this.props.apiActions
      .get({
        resource: 'CONTENT',
        id: this.props.params.id,
      })
      .then(data => {
        const metadata = JSON.parse(data[0].metadata);
        this.setState({
          yfparams: metadata.YFSettings,
          yfheight: metadata && metadata.YFHeight ? metadata.YFHeight : null,
        });
        this.getSSOToken();
      });
  }

  getSSOToken() {
    const { companyCode, countryCode } = this.props;
    const { yfparams: rawParams } = this.state;

    const yfparams = rawParams ? this.convertYFParams(rawParams) : [];

    this.props.actions.fetchYellowfinSSO({
      companyCode: companyCode.value,
      countryCode,
      yfparams,
    });
  }

  goBack = () => {
    const { router } = this.context;
    router.push(Routes.INSIGHTS)
  };

  convertYFParams(yfparams) {
    const { restrictions, companyCode } = this.props;
    const sourceYFParams = [];

    const restrictionObj = {
      companyCode: companyCode.label.trim(),
    };

    let regexStr;
    if (restrictions && restrictions.length > 0) {
      restrictions.forEach(ea => (restrictionObj[ea.typeId] = ea.values));

      // Build filter text regex to catch all restrictions selections
      // URL Template -- FILTER_1231231={typeId1}
      // will replace {typeID1} with restriction typedId 1 value
      const filterKeys = Object.keys(restrictionObj)
        .reduce((acc, currval) => `${acc + currval}|`, '')
        .slice(0, -1);
      const regStr = `\{typeId([${filterKeys}])\}`;
      regexStr = new RegExp(regStr, 'gi');
    }

    Object.keys(yfparams).forEach(item => {
      if (/title/.test(item)) return;

      // If YF Param doesn't content filter pass it on into iframe
      if (!/filter/gi.test(item))
        sourceYFParams.push(`${item}=${yfparams[item]}`);

      if (/companyCode/.test(yfparams[item])) {
        const newFilter = yfparams[item].replace(
          '{companyCode}',
          encodeURIComponent(restrictionObj.companyCode)
        );
        return sourceYFParams.push(`${item}=${newFilter}`);
      }

      // if there is no restrictions hide filter param
      if (!restrictions || restrictions.length === 0) return false;

      // Execute replace logic
      regexStr.lastIndex = 0;
      const regRes = regexStr.exec(yfparams[item]);
      if (regRes && regRes.length > 0) {
        const filVal = restrictionObj[regRes[1]]
          .reduce((acc, curr) => `${acc + curr}|`, '')
          .slice(0, -1);

        const newFilter = yfparams[item].replace(
          regRes[0],
          encodeURIComponent(filVal)
        );
        sourceYFParams.push(`${item}=${newFilter}`);
      }
    });

    return sourceYFParams;
  }

  render() {
    const { yfparams, yfheight } = this.state;
    const { token, yfhost, status } = this.props;
    let iframeUrl = '';
    let title = '';
    let panelContent = <p> You are not authorized to view this content </p>;


    if (yfparams === null) {
      panelContent = <NitroLoading />;
    } else {
      ({ title } = yfparams);
    }

    if (status !== 'failed') {
      if (!token || token === '') panelContent = <NitroLoading />;
      else {
        iframeUrl = `${yfhost}logon.i4?LoginWebserviceId=${token}`;
        panelContent = (
          <YellowfinIframe
            yfheight={yfheight}
            iframeUrl={iframeUrl}
          />
        );
      }
    }

    return (
      <section>
        <Breakpoint name="desktop">
          <SectionHeader margin="40px 0">
            <LeftSection>
              <NitroNavBar label={title || ''} action={this.goBack} header />
            </LeftSection>
          </SectionHeader>
        </Breakpoint>

        <OverflowPanel>
          <NitroPanelExtended>
            { panelContent }
          </NitroPanelExtended>
        </OverflowPanel>

      </section>
    );
  }
}

EmbedDisplay.contextTypes = {
  router: PropTypes.object,
};

EmbedDisplay.PropTypes = {
  isFetching: PropTypes.bool,
  companyCode: PropTypes.object,
  token: PropTypes.string,
  actions: PropTypes.object.isRequired,
  location: PropTypes.object,
  restrictions: PropTypes.array,
};

export default EmbedDisplay;



// WEBPACK FOOTER //
// ./src/features/yellowfin/EmbedDisplay.js